import commonActionTypes from './action-types';

export const setContext = value => ({
  type: commonActionTypes.SET_CONTEXT,
  payload: value,
});

export const setSubContext = value => ({
  type: commonActionTypes.SET_SUB_CONTEXT,
  payload: value,
});
